export default __webpack_public_path__ + "static/media/CNo.20-0.8007770b.jpg";